<template>
  <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="相关展品" name="first">
      <v-collection :exhibitionId="exhibitionId"></v-collection>
    </el-tab-pane>
    <el-tab-pane label="相关视频" name="second">
      <v-video :exhibitionId="exhibitionId"></v-video>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import collection from './collection'
import video from './video'
export default {
  components: {
    'v-collection': collection,
    'v-video': video
  },
  data() {
    return {
      activeName: "first",
      exhibitionId: ""
    }
  },

  methods: {
    handleClick() {

    }
  },

  mounted(){
    this.exhibitionId = this.$route.query.exhibitionId
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  background: #fff;
  display: flex;
  flex-direction: column;
  /deep/.el-tabs__nav-wrap {
    &::after{
      display: none;
    }
    .el-tabs__nav-scroll {
      display: flex;
      justify-content: center;
    }
  }

  /deep/.el-tabs__content{
    flex: 1;
  }
}
</style>
</style>